import { useState } from "react";
import { gql, useQuery } from "@apollo/client";

// Constants
import { catFields } from "@/constants/gql-fields";

export default function TermsFilter({ postType, setFilter }) {
  const [selectedCat, setSelectedCat] = useState("All");

  let getCats,
    catName = "";
  if (postType == "posts") {
    getCats = useQuery(GET_CATS, {
      variables: { isPosts: true },
    });
    catName = "categories";
  }
  // else if (postType == "events") {
  //   getCats = useQuery(GET_CATS, {
  //     variables: { isEvents: true },
  //   });
  //   catName = "eventTypes";
  // }

  if (getCats.loading) {
    return (
      <select>
        <option>Loading...</option>
      </select>
    );
  }
  if (getCats.error) {
    return;
  }

  const catData = getCats.data?.[catName].nodes;

  return (
    <div>
      {catData && (
        <select
          value={selectedCat}
          onChange={(e) => {
            setSelectedCat(e.target.value);
            setFilter(e.target.value);
          }}
        >
          <option value={"All"}>Filter</option>
          {catData.map((cat, i) => {
            return (
              <option value={cat.name} key={i}>
                {cat.name}
              </option>
            );
          })}
        </select>
      )}
    </div>
  );
}

const GET_CATS = gql`
  query GET_CATS($isPosts: Boolean! = false) {
    categories @include(if: $isPosts) {
      nodes {
        ${catFields}

      }
    }
    # eventTypes @include(if: $isEvents) {
    #   nodes {
    #     ${catFields}
    #   }
    # }
  }
`;
